// src/components/HRCampusSelector.js
import React from "react";

const campuses = [
  { id: "bulacan", name: "Bulacan" },
  { id: "gapan", name: "Gapan City" }
];

export default function HRCampusSelector({ selectedCampus, onChange, allowAll }) {
  return (
    <div className="mb-3" style={{ display: "flex", alignItems: "center", gap: 12 }}>
      <label htmlFor="campus-select" className="form-label mb-0" style={{ fontWeight: 500 }}>
        Campus:
      </label>
      <select
        id="campus-select"
        className="form-select form-select-sm"
        style={{ width: 180 }}
        value={selectedCampus}
        onChange={e => onChange(e.target.value)}
      >
        {allowAll && <option value="">All Campuses</option>}
        {campuses.map(campus => (
          <option key={campus.id} value={campus.id}>{campus.name}</option>
        ))}
      </select>
    </div>
  );
}
